export enum enumBacAccStatus {
  'Reject' = 1,
  'Accept',
  'Transfer To Suspense Account',
}

export namespace enumBacAccStatus {
  export function values() {
    return Object.keys(enumBacAccStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
